<template>
  <div
    v-if="isDev"
    class="bg-primary/5 text-foreground border-primary fixed bottom-1 right-1 z-9999 rounded border px-3 py-0.5 text-xs font-medium"
  >
    <div class="sm:hidden">xs</div>
    <div class="hidden sm:block md:hidden">sm</div>
    <div class="hidden md:block lg:hidden">md</div>
    <div class="hidden lg:block xl:hidden">lg</div>
    <div class="hidden xl:block 2xl:hidden">xl</div>
    <div class="hidden 2xl:block">2xl</div>
  </div>
</template>
<script setup lang="ts">
const isDev = import.meta.env.DEV;
</script>
